import { jwtDecode } from 'jwt-decode'
import moment from 'moment'
import { getDomain } from '@/helpers/brandHelper.js'
import { getLoginRedirectUrl } from '@/helpers/envHelper.js'

class AuthUjwtHelper {
  constructor() {
    this.token = null
    this.expiryDate = null
    this.refreshCallback = null
    this.refreshPromise = null
    this.productInstanceId = null
    this.onTokenRefresh = null
    this.redirectUrl = `https://${getDomain()}/${getLoginRedirectUrl()}`
  }

  setOnTokenRefresh = (fn) => {
    this.onTokenRefresh = fn
  }

  setProductInstanceId = (pId) => {
    this.productInstanceId = pId
  }

  setRefreshCallback = (callback) => {
    this.refreshCallback = callback
  }

  setToken = (token) => {
    this.token = token
  }

  monitorToken = async () => {
    if (this.refreshPromise) {
      await this.refreshPromise
    }
  }

  checkAuth = async () => {
    await this.monitorToken()
    if (!this.token) {
      return this.retrieveAuthToken(this.productInstanceId)
    }
    if (!this.expiryDate) {
      this.expiryDate = this.getExpiryDate(this.token)
    }

    if (this.isExpired()) {
      return this.retrieveAuthToken(this.productInstanceId)
    }
    return this.token
  }

  isExpired = () => this.expiryDate && this.expiryDate <= moment().unix()

  retrieveAuthToken = async () => {
    if (!this.refreshCallback) {
      console.warn('A callback to refresh the auth token must be set when initializing the MFE')
      return
    }

    if (!this.refreshPromise) {
      this.refreshPromise = new Promise(async (resolve, reject) => {
        try {
          const newToken = await this.refreshCallback(this.productInstanceId)
        if(!newToken) {
          window.location.href = this.redirectUrl
          reject('Token not found')
        }
        this.token = newToken
        this.expiryDate = this.getExpiryDate(this.token)
        resolve()
        }
        catch {
          window.location.href = this.redirectUrl
        }
        
      })
    }

    await this.refreshPromise

    if(this.onTokenRefresh) {
      this.onTokenRefresh(this.token)
    }

    this.refreshPromise = null
    return this.token
  }

  decodeToken = (token) => {
    try {
      const decoded = jwtDecode(token)
      return decoded
    } catch (error) {
      console.error('Error decoding token:', error)
      return null
    }
  }

  getExpiryDate = (token) => {
    if (token) {
      const { exp: expiryDate } = this.decodeToken(token)

      if (expiryDate) {
        return expiryDate
      }

      return null
    }
  }
}

export default new AuthUjwtHelper()
